<template>
  <!--
    	作者：wangxw
    	时间：2019-10-26
    	描述：产品分类管理
    -->
  <div class="product">
    <div style='margin-bottom:20px;border:1px solid pink;border-radius: 4px;'>
      <el-alert title="注意：" :closable="false" type="warning" show-icon>
        <template #title>
          <div style='margin:10px 20px '>
            <p>
              1.技师列表显示的公里数是按当前用户位置与技师填写的服务接单地址计算获得（直线距离）<br> 2.订单路费计算规则{根据用户填写的下单地址与技师服务接单地址进行驾车路线计算（通过第三方高德地图API）
              <a href="https://lbs.amap.com/" target="_blank">高德地图(点击查看)</a><br> 3.如产生技师反馈路费给予少的情况下，一般导致原因是地址设置填写不够准确（精度）。
              <br>

            </p>
            <p style='margin-top:16px;color:#3a8ee6'>
              避免情况发生：<br> 1.技师须确保自身的接单位置是正确，与切身利益挂钩，建议技师保持核对位置习惯
              <br> 2.用户填写订单的位置尽可能精准，譬如什么酒店，如设置什么路口则产生1~3公里范围偏差计算
              <br> 3.路费计算毕竟是通过起点与终点两者距离进行计算，如设置位置不够准确则产生计算误差
            </p>
          </div>
        </template>
      </el-alert>
    </div>
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="订单编号">
          <el-input size="small" v-model.trim="searchForm.orderNo" placeholder="请输入订单编号"></el-input>
        </el-form-item>
        <el-form-item label="支付时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker size="small" v-model="searchForm.createTime" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" row-key="categoryId" border default-expand-all :tree-props="{children: 'child'}" style="width: 100%" v-loading="loading">
          <el-table-column prop="name" label="订单信息" width="180">
            <template slot-scope="scope">
              <div>
                <p style='color:orange'>订单ID:
                  <span>{{scope.row.orderId}}</span>
                </p>
                <p>订单编号：
                  <span>{{scope.row.orderNo}}</span>
                </p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="waiterAddress" label="技师接单地址">
            <template slot-scope="scope" v-if='scope.row.waiterAddress'>
              <div>
                <p style='color:orange'>技师id:
                  <span>{{scope.row.waiterAddress.waiter_user_id}}</span>
                </p>
                <p>地址：
                  <span>{{scope.row.waiterAddress.detail}}</span>
                </p>
                <p>手机号：
                  <span>{{scope.row.waiterAddress.mobile}}</span>
                </p>
                <p style='color:#3a8ee6'>（经度:{{scope.row.waiterAddress.lng}}纬度:{{scope.row.waiterAddress.lat}}）</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="用户下单地址">
            <template slot-scope="scope" v-if='scope.row.address'>
              <div>
                <p style='color:orange'>用户:
                  <span>{{scope.row.address.name}}</span>
                </p>
                <p>地址：
                  <span>{{scope.row.address.text}}</span>
                </p>
                <p>手机号：
                  <span>{{scope.row.address.phone}}</span>
                </p>
                <p style='color:#3a8ee6'>（经度:{{scope.row.address.lng}}纬度:{{scope.row.address.lat}}）</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="farePrice" label="订单路费金额">
            <template slot-scope="scope">
              <span style='color:orange'>￥{{scope.row.farePrice}}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="text" label="城市"></el-table-column> -->
          <el-table-column prop="distance" label="距离">
            <template slot-scope="scope">
              <span style=''>{{scope.row.distance? scope.row.distance:0}}Km</span>
            </template>
          </el-table-column>
          <el-table-column prop="fare_param_json" label="交通信息">
            <template slot-scope="scope">
              <div v-if="scope.row.fare_param_json">
                <p style='color:orange'>出行方式：
                  <span >{{scope.row.fare_param_json.name}}</span>
                </p>
                <p>费用：
                  <span>￥{{scope.row.fare_param_json.price}}（{{scope.row.fare_param_json.msg}}）</span>
                </p>
                <p>出行距离：
                  <span>{{scope.row.fare_param_json.distance}}</span>
                </p>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import OrderApi from "@/api/order.js";

export default {
  components: {},
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*当前编辑的对象*/
      categoryModel: {
        catList: [],
        model: {}
      },
      searchForm: {
        orderNo: "",
        createTime: ""
      }
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },
    /*获取列表*/
    getData() {
      let self = this;
      let Params = self.searchForm;
      Params.pageIndex = self.curPage;
      Params.pageSize = self.pageSize;
      OrderApi.orderJourney(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.data;
          console.log(self.tableData)
          self.totalDataNumber = data.data.total;
        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/order/ordertrip/index.vue